import {Box, VStack} from '@chakra-ui/react';
import {CatalogueViewAccueil} from './components/CatalogueViewAccueil';
import {OperationCommercialeListeView} from '@/domains/operation_commerciale/OperationCommercialeListeView.tsx';
import {MaintenanceBanner} from '@/components/MaintenanceBanner/MaintenanceBanner';
import {PaiementCBNotice} from '@/components/PaiementCBNotice/PaiementCBNotice';
import {AccueilHeaderDesktop} from './components/AccueilHeaderDesktop';
import {AccueilHeaderMobile} from './components/AccueilHeaderMobile';

/**
 * Page d'accueil de l'interface client (route `accueil`) : bandeaux d'information (maintenance,
 * paiement par carte), bloc d'accueil, puis les opérations commerciales « En ce moment » et les
 * promotions du catalogue. Le bloc d'accueil existe en deux versions :
 * - `AccueilHeaderMobile` sur petit écran
 * - `AccueilHeaderDesktop` sur grand écran.
 */
export const AccueilView: React.FC = () => {
  return (
    <VStack
      width='100%'
      gap='0'
      position='relative'
      bg='gray.75'
    >
      <MaintenanceBanner />
      <PaiementCBNotice />
      {/* Les deux versions sont montées : leur `display` n'en affiche qu'une, selon la largeur (seuil `lg`) */}
      <AccueilHeaderMobile />
      <AccueilHeaderDesktop />
      {/* Sections « En ce moment » et promotions */}
      <Box width='100%'>
        <OperationCommercialeListeView context='accueil' />
        <CatalogueViewAccueil />
      </Box>
    </VStack>
  );
};
